import React, { useRef, useState } from "react";
import searchIcon from "../../../../assets/img/company/SearchIcon.svg";
import closeIcon from "../../../../assets/img/company/closeIcon.svg";
import downloadIcon from "../../../../assets/img/company/donwloadIcon.svg";
import greyCircle from "../../../../assets/img/company/grey-circle.svg";
import redCircle from "../../../../assets/img/company/red-circle.svg";
import { generateAllLogsXML } from "../../../../helpers/helpers";
import toast from "react-hot-toast";
function Logs({ isDownloadable = false, allLogs, totalCount, searchValue, setSearchValue, loadMoreZatcaLogs, allLogsCount }) {
  const [searchBarOpen, setSearchBarOpen] = useState(false);
  const [closeSearchBarIfValue, setCloseSearchBarIfValue] = useState(true);

  const searchRef = useRef();
  const handleOutsideClickSearch = (event) => {
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      if (!closeSearchBarIfValue) {
        setSearchBarOpen(true);
      } else {
        setSearchBarOpen(false);
      }
    }
  };
  React.useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClickSearch);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClickSearch);
    };

    // eslint-disable-next-line
  }, [closeSearchBarIfValue]);

  let zatcaLogsData = allLogs?.map((item) => ({
    header: item?.logMessage,
    status: item?.additionalInfo?.response,
    data: [
      { title: "Time", description: item?.createdAt },
      {
        title: "Actor",
        description: (
          <>
            <div>{item?.additionalInfo?.userName}</div>
            <div>ID {item?.additionalInfo?.userId}</div>
          </>
        ),
      },
      {
        title: "Device",
        description: (
          <>
            <div>{item?.additionalInfo?.posName}</div>
            <div>ID {item?.additionalInfo?.posId}</div>
          </>
        ),
      },
      {
        title: "Store",
        description: (
          <>
            <div>{item?.additionalInfo?.storeName}</div>
            <div>ID {item?.additionalInfo?.storeId}</div>
          </>
        ),
      },
      { title: "CSID", description: item?.additionalInfo?.certificateId },
      // { title: "Request Time", description: item?.createdAt },
      { title: "Request Time", description: item?.additionalInfo?.requestTime },
      { title: "Request ID", description: item?.additionalInfo?.requestId },
      { title: "Response Time", description: item?.additionalInfo?.responseTime },
      { title: "Response ID", description: item?.additionalInfo?.responseId },
      {
        title: "Response",
        description:
          item?.additionalInfo?.response === "Failed"
            ? `${item?.additionalInfo?.response} [${item?.additionalInfo?.failReason}]`
            : item?.additionalInfo?.response,
      },
    ],
  }));

  const handleDownloadAllLogsOfPos = () => {
    if (!allLogs || allLogs.length === 0) return;

    const xml = generateAllLogsXML(allLogs);
    const blob = new Blob([xml], { type: "application/xml" });
    const url = window.URL.createObjectURL(blob);
    const timestamp = new Date()
      .toISOString()
      .replace(/[-:.]/g, "")
      .slice(0, 15);

    const a = document.createElement("a");
    a.href = url;
    a.download = `pos_logs_${timestamp}.xml`;
    a.click();
    window.URL.revokeObjectURL(url);

    toast.success("XML generated successfully");
  };

  return (
    <div>
      <div className="bg-white p-3 zatca-logs-radius">
        {isDownloadable ? (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <div className="changes-logs-text">Changes Log:</div>
              <div style={{ cursor: "pointer" }} onClick={handleDownloadAllLogsOfPos}>
                <img src={downloadIcon} alt="download" />
              </div>
            </div>
          </>
        ) : (
          <div className={`d-flex justify-content-between align-items-center `}>
            {!searchBarOpen && <div className="changes-logs-text">Changes Log:</div>}

            <div className="d-flex justify-content-between align-items-center mb-3" style={{ marginTop: searchBarOpen ? "1.4rem" : "" }}></div>
            <div className="searchIcon-wrap" ref={searchRef} style={{ position: "relative", width: searchBarOpen ? "100%" : "inherit" }}>
              <div style={{ width: "100%", height: "34px" }}>
                {searchBarOpen ? (
                  <input
                    value={searchValue}
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                      //  handleSearchLogs(e.target.value);
                    }}
                    type="text"
                    style={{
                      color: searchValue.length ? "#4F4F4F" : "#BDBDBD",
                      fontWeight: !searchValue.length ? 500 : 700,
                    }}
                    className="searchBar logs-search-bar"
                    placeholder={`Search`}
                  />
                ) : null}

                <div style={{ position: "absolute", top: 7, right: 20 }}>
                  {searchValue.length && searchBarOpen ? (
                    <img
                      src={closeIcon}
                      alt="search icon"
                      onClick={() => {
                        setSearchValue("");
                        // resetSearchingHandler();
                        setCloseSearchBarIfValue(true);
                      }}
                    />
                  ) : (
                    <img
                      src={searchIcon}
                      className="cursor-pointer"
                      alt="search icon"
                      onClick={() => {
                        setSearchBarOpen(!searchBarOpen);
                      }}
                      width={20}
                      height={20}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* log details to show */}
      {/* <div className="bg-white p-3 zatca-logs-radius logs-detail-wrapper mt-3" style={{ justifyContent: "start", alignItems: "start" }}>
        <div className="logs-container d-flex align-items-start relative" style={{ gap: "1rem", position: "relative" }}>
          <div>
            <img src={greyCircle} alt="circle" />
          </div>
          <div>
            <div className="logs-main-title">Link Device | Production</div>
            {logsData?.map((item) => {
              return (
                <>
                  <div className="logs-small-text pt-1">{item?.title}</div>
                  <div className="logs-normal-text">{item?.description}</div>
                </>
              );
            })}
          </div>
          <div
            className="vertical-line"
            style={{ position: "absolute", width: "2px", background: "#DEE5E9", height: "93%", left: "6px", top: "1.8rem" }}
          ></div>
        </div>
      </div> */}

      <div className="bg-white p-3 zatca-logs-radius mt-3">
        {zatcaLogsData?.map((log, logIndex) => (
          <div key={logIndex} className="log-entry" style={{ position: "relative" }}>
            <div className="d-flex align-items-start mt-2" style={{ justifyContent: "start" }}>
              {/* Circle for this log */}
              <img src={log?.status === "Failed" ? redCircle : greyCircle} alt="circle" />

              <div>
                {/* Log header (logMessage) */}
                <span className="ml-2" style={{ color: "#236DD1", fontSize: "16px", fontWeight: "400" }}>
                  {log.header}
                </span>

                {/* Log details */}
                {log?.data?.map((item) => {
                  return (
                    <div className="ml-2">
                      <span className="pt-1" style={{ color: "#8C8C8C", fontWeight: "400", fontSize: "12px" }}>
                        {item?.title}
                      </span>
                      <br />
                      <span style={{ color: "#333333", fontWeight: "400", fontSize: "15px" }}>{item?.description}</span>
                    </div>
                  );
                })}
              </div>
            </div>
            <div
              style={{
                width: " 4px",
                backgroundColor: "#e0e0e0",
                position: "absolute",
                borderRadius: "3px",
                left: "7px",
                zIndex: "1",
                top: "17px",
                bottom: "1px",
              }}
            ></div>
          </div>
        ))}
        {Number(allLogsCount) > Number(totalCount) ? (
          <div className="p-2 pt-5" style={{ cursor: "pointer", fontSize: "14px" }} onClick={loadMoreZatcaLogs}>
            Load More
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default Logs;
